import React from 'react';
import cn from 'classnames';
import { useCollaboration } from '../../../../entities/collaboration';
import { Icon, Tooltip } from '../../../../shared/ui';
import { IconMap } from '../../../../shared/sprite';

type Props = {
  isTemplateMode: boolean;
};

export const PageStatusInfo: React.FC<Props> = ({ isTemplateMode }) => {
  const { isPageSaved } = useCollaboration();

  if (isTemplateMode) {
    return null;
  }

  return (
    <Tooltip
      trigger={
        <div className={'flex items-center h-9 sm:hidden'}>
          <Icon
            width={isPageSaved ? 12 : 16}
            glyph={isPageSaved ? IconMap.Checked : IconMap.InfoCircle}
            className={cn('shrink-0 text-gray-600 ', {
              'text-warning-600': !isPageSaved,
            })}
          />
        </div>
      }
      sideOffset={4}
    >
      <p className="px-2 py-1 font-semibold text-xs">
        {isPageSaved ? 'Changes saved' : 'Changes not saved'}
      </p>
    </Tooltip>
  );
};
